module.exports = __webpack_public_path__ + "img/slide10.8e787479.png";